import type * as exceljs from 'exceljs'

import type { Cell } from './cell'

// TODO: add JSDoc examples

/**
 * Represents a row in an Excel sheet
 */
export class Row {
  /**
   * Creates a single {@link Row} with no cells
   */
  public static empty(): Row
  /**
   * Creates the requested number of {@link Row}, each with no cells
   */
  public static empty(count: number): Row[]
  public static empty(count?: number): Row | Row[] {
    if (count === undefined) {
      return new Row()
    }

    // NOTE: we need to make sure each Row is a separate instance, which is
    // why we don't just pass Row.empty() to fill
    return new Array(count).fill(0).map(_ => Row.empty())
  }

  public readonly cells: Cell[]
  public readonly style: Partial<exceljs.Style>

  constructor(...cells: readonly Maybe.ReadonlyArray<Cell>[]) {
    this.cells = cells.flat()
    this.style = {}
  }

  public addCell(cell: Cell): this {
    this.cells.push(cell)
    return this
  }

  public addCells(cells: Cell[]): this {
    this.cells.push(...cells)
    return this
  }

  public borderBottom(borderBottom: Partial<exceljs.Border>): this {
    this.cells.forEach(cell => cell.borderBottom(borderBottom))
    return this
  }

  public borderTop(borderTop: Partial<exceljs.Border>): this {
    this.cells.forEach(cell => cell.borderTop(borderTop))
    return this
  }
}
